import { Rocket, Zap, TrendingUp, Repeat, ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

const METRIC = {
  activation: { label: "Activation", icon: Zap, color: "#00F0FF" },
  conversion: { label: "Conversion", icon: TrendingUp, color: "#10B981" },
  retention: { label: "Retention", icon: Repeat, color: "#A78BFA" },
};
const PRIORITY = { P0: "#EF4444", P1: "#F59E0B", P2: "#71809A" };
const EFFORT = { LOW: "#10B981", MEDIUM: "#F59E0B", HIGH: "#EF4444" };

export function GrowthRecommendations({ recommendations }) {
  if (!recommendations || recommendations.length === 0) return null;
  return (
    <div className="sim-card-elevated rounded-xl p-5" data-testid="sim-growth-recs">
      <div className="flex items-center gap-2 mb-1">
        <Rocket className="w-4 h-4 text-[#00F0FF]" />
        <h3 className="sim-head text-lg font-bold text-[#F5F5F5]">Growth Recommendations</h3>
      </div>
      <p className="text-[#C2C5CE] text-[13px] mb-4">
        Prioritized product actions synthesized from the agents' reactions to lift your usage metrics.
      </p>
      <div className="space-y-2.5">
        {recommendations.map((r, i) => {
          const m = METRIC[r.metric] || METRIC.activation;
          const Icon = m.icon;
          return (
            <div key={i} data-testid={`sim-growth-rec-${i}`} className="sim-card rounded-lg p-4 border-l-2" style={{ borderLeftColor: m.color }}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="sim-mono text-[9px] font-bold px-1.5 py-0.5 rounded shrink-0"
                    style={{ color: PRIORITY[r.priority] || "#71809A", border: `1px solid ${(PRIORITY[r.priority] || "#71809A")}55` }}>
                    {r.priority}
                  </span>
                  <h4 className="text-[#F5F5F5] text-sm font-semibold truncate">{r.title}</h4>
                </div>
                <span className="sim-mono text-[9px] flex items-center gap-1 shrink-0" style={{ color: m.color }}>
                  <Icon className="w-3 h-3" /> {m.label.toUpperCase()}
                </span>
              </div>
              <p className="text-[#D4D4D8] text-[13px] mt-2 leading-relaxed">{r.recommendation}</p>
              {r.rationale && <p className="text-[#9AA0AC] text-[12px] mt-1.5 leading-relaxed">{r.rationale}</p>}
              <div className="flex items-center flex-wrap gap-x-4 gap-y-1 mt-2.5 sim-mono text-[10px]">
                {r.expected_impact && (
                  <span className="flex items-center gap-1 text-[#10B981]">
                    <ArrowUpRight className="w-3 h-3" /> {r.expected_impact}
                  </span>
                )}
                <span className="text-[#9AA0AC]">
                  Effort: <span style={{ color: EFFORT[r.effort] || "#9AA0AC" }}>{r.effort}</span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
